export const fieldLocationName = {
  name: 'location-name',
  nickname: 'Nome do Local',
  type: 'text',
  hasborder: 'yes',
  label: 'Nome do Local',
};
